export default '0.14.4';



// WEBPACK FOOTER //
// ./version.js